import styles from './index.module.sass';
import ArrowSvg from '../icons/arrow';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

export const SelectBunker = ({ bunker, onChange, options }: IInputSelect) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const myRef = useRef<HTMLInputElement>(null);
  const offsetWidth = myRef.current?.offsetWidth;
  const offsetHeight = myRef.current?.offsetHeight;
  const coords = myRef.current?.getBoundingClientRect();

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (myRef.current && !myRef.current.contains(event.target)) {
        setDropdownActive(false);
      }
    }

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={myRef}
      className={classNames(styles.inputSelect, dropdownActive && styles.inputActive)}
      onClick={() => setDropdownActive(!dropdownActive)}
    >
      <div className={styles.inputBody}>
        <span className={styles.label}>
          {bunker.label !== '' ? `${bunker.label}` : 'бункер не выбран'}
        </span>
        <span className={styles.arrow}>
          <ArrowSvg active={dropdownActive} />
        </span>
      </div>
      {dropdownActive && (
        <div
          className={styles.dropdownBody}
          style={{
            top: Number(coords?.top) + Number(offsetHeight),
            left: coords?.left,
            width: offsetWidth,
          }}
        >
          <ul className={styles.dropdownList}>
            {options
              .sort(function (a, b) {
                var keyA = new Number(a.tonnage),
                  keyB = new Number(b.tonnage);
                if (keyA < keyB) return -1;
                if (keyA > keyB) return 1;
                return 0;
              })
              .map((option, i) => (
                <li
                  key={i}
                  className={classNames(
                    styles.dropdownListItem,
                    bunker?.id === option.value && styles.activeItem,
                  )}
                  onClick={() => {
                    onChange(option);
                    setDropdownActive(false);
                  }}
                >
                  <span className={styles.itemLabel}>{option.label}</span>
                  <span>{option.tonnage} т</span>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

interface IInputSelect {
  bunker: { id: number | string; label: string };
  onChange: Function;
  options: {
    value: number | string;
    label: string | number;
    tonnage: number | string;
  }[];
}
